import React, { FC, createContext, useContext, useMemo } from 'react';

import { IServerOrder } from '@rbi-ctg/menu';
import { StoreProxy } from 'state/store';

import { IFlyBuyContext } from './types';

export const FlyBuyContext = createContext<IFlyBuyContext>({} as IFlyBuyContext);

export const useFlyBuyContext = () => useContext(FlyBuyContext);

export const FlyBuyProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const value = useMemo(
    () => ({
      isAvailable: false,
      isReady: false,
      init: async () => {},
      checkPermissions: async () => false,
      isCheckingPermissions: false,
      createOrder: async (serverOrder: IServerOrder, store: StoreProxy) => {},
    }),
    []
  );

  return <FlyBuyContext.Provider value={value}>{children}</FlyBuyContext.Provider>;
};
